import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdminTransferList from "./admin-transfer-list/admin-transfer-list";

const AdminTransfers = () => {
  return (
    <Routes>
      <Route index element={<AdminTransferList />} />
    </Routes>
  )
}

export default AdminTransfers;
